import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import Settings from "components/settings";
import { TranslationAiRequestsPage, TranslationAiUsagePage } from "components/pages/settings";

export default function SettingsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Redirect to={ Settings.Const.translationAiUsagePath } />
            </Route>
            <Route path={ `${ path }/translation-ai-usage` } exact>
                <TranslationAiUsagePage />
            </Route>
            <Route path={ `${ path }/translation-ai-usage/page/:pageNum` } exact>
                <TranslationAiUsagePage />
            </Route>
            <Route path={ `${ path }/translation-ai-requests` } exact>
                <TranslationAiRequestsPage />
            </Route>
            <Route path={ `${ path }/translation-ai-requests/page/:pageNum` } exact>
                <TranslationAiRequestsPage />
            </Route>
        </Switch>
    );
}
